module.exports = __webpack_public_path__ + "img/ccl_gallery0.dad308a5.jpg";